import {TheBorderXWaysSymbol} from "../reels/TheBorderXWaysSymbol";
import {ISymbolPosition} from "../../core/reel/ReelInterfaces";
import {TheBorder} from "../TheBorder";
import {gsap} from "gsap";

/**
 * Created by Jerker Nord on 2022-05-12.
 */

export class TheBorderXWaysSymbols {

    private _xWaysSymbols:TheBorderXWaysSymbol[];

    constructor() {}

    public init():void {
        this._xWaysSymbols = [];
        for(let i:number = 0; i < 10; i++) {
            this._xWaysSymbols.push(this.createNewXWaysSymbol());
        }

        const tempSym:TheBorderXWaysSymbol = this.createNewXWaysSymbol();
        TheBorder.gpuPushView.addChild(tempSym);
        tempSym.visible = true;
        gsap.timeline({delay : TheBorder.gpuPushView.delay}).add(tempSym.getLandingAnimation().restart());
    }

    private createNewXWaysSymbol():TheBorderXWaysSymbol {
        return new TheBorderXWaysSymbol();
    }

    public getXWaysSymbol(symbolPositionData:ISymbolPosition):TheBorderXWaysSymbol {
        for(let i:number = 0; i < this._xWaysSymbols.length; i++) {
            if(this._xWaysSymbols[i].isUsed == false) {
                this._xWaysSymbols[i].isUsed = true;
                this._xWaysSymbols[i].isRemoved = false;
                this._xWaysSymbols[i].reelId = symbolPositionData.reelId;
                this._xWaysSymbols[i].reelPosition = symbolPositionData.startPosition;
                return this._xWaysSymbols[i];
            }
        }
        this._xWaysSymbols.push(this.createNewXWaysSymbol());
        return this.getXWaysSymbol(symbolPositionData);
    }

    public getXWaysSymbolOnReelArea(reel:number, row:number):TheBorderXWaysSymbol {
        for(let i:number = 0; i < this._xWaysSymbols.length; i++) {
            if(this._xWaysSymbols[i].isUsed == true && this._xWaysSymbols[i].reelId == reel && this._xWaysSymbols[i].reelPosition == row) {
                return this._xWaysSymbols[i];
            }
        }
        throw new Error("No active XWays symbol on reel " + reel + " row " + row + "!!");
    }

    public turnOffAllXWaysSymbols():void {
        for(let i:number = 0; i < this._xWaysSymbols.length; i++) {
            if(this._xWaysSymbols[i].isUsed == true) {
                this._xWaysSymbols[i].turnOffSymbolSpine();
            }
        }
    }
}